module.exports = __webpack_public_path__ + "ce6d6ae682109436044fb5b1089edcae.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1080
// module chunks = 0